export default {
    intro: `字根是组成单词的最小要素。<br />
            一起来看看由字根组成的单词和字之间的关系吧。`,
    options: { textbook: '课本中的单词', page: '课本' },
    header: {
        round: ({ values }: { values: { round: number } }) => {
            const { round } = values;
            return `第${round === 1 ? '一' : '二'}个字`;
        },
        title: {
            word: '字',
            example1: '例词1',
            example2: '例词2',
            check: '确认学过的单词',
            question: '单词问题',
            meaning: '确认语义关系',
            meaningQuestion: '语义关系问题',
        },
    },
    indicator: {
        word: '学习字根的形状、读音和含义。',
        example1: '了解字根在单词中的用法。',
        example2: '了解字根在单词中的用法。',
        check: '学习包含字根的两个单词。',
        question: '两个单词中，使用了"{ reading }({ cn })"字的单词是哪一个？',
        meaning: '了解字根在单词中的用法。',
        meaningQuestion: '{ first }和{ second }的关系是什么？',
        // 按类型的关系说明句（0 近义 / 1 反义 / 2 上下义 / 3 同形 / 4 多义）
        desciption: {
            0: '<strong>{ first }</strong>和<strong>{ second }</strong>意思相近。',
            1: '<strong>{ first }</strong>和<strong>{ second }</strong>意思相反。',
            2: '<strong>{ first }</strong>包含<strong>{ second }</strong>的意思。',
            3: '<strong>{ first }</strong>和<strong>{ second }</strong>都读作{ sound }，但意思不同。',
            4: '<strong>{ first }</strong>既有<strong>{ meaning1 }</strong>的意思，也有<strong>{ meaning2 }</strong>的意思。',
        },
    },
    toast: {
        cube: ({ values }: { values: { isTeacher: boolean } }) => {
            const { isTeacher } = values;
            return isTeacher ? '这是学生自己旋转立方体学习的环节。' : '自己旋转立方体来学习字吧。';
        },
        wrongAnswer: {
            lead: '再想一想？',
            body: '看看含义，选择合适的单词。',
        },
    },

    description: ({ values }: { values: { type: number } }) => {
        const { type } = values;
        if (type === 0) {
            return '近义';
        }
        if (type === 1) {
            return '反义';
        }
        if (type === 2) {
            return '上下义';
        }
        if (type === 3) {
            return '同形';
        }
        if (type === 4) {
            return '多义';
        }
        if (type === 5) {
            return '无';
        }
        return '无';
    },
    relationResult: {
        lead: '这种关系叫做',
        tail: () => '。',
    },
    result: { correct: '正确', incorrect: '不正确', selected: '已选' },
    buttons: {
        next: '下一个',
        learn: '学习单词',
        nextLearn: '下一个单词',
        collectWord: '汇总单词',
        check: '确认学过的单词',
        seoncdLearn: '学习第二个字',
        relation: '学习语义关系',
        prev: '上一步',
        finishStudy: '完成学习',
        desciption: '查看说明',
    },
    guide: {
        cube: '点击立方体来旋转吧。',
    },
    study: {
        example: '例句',
        meaning: '含义',
    },
};
